import { Action } from '../actions/reviews';
import { toQueryString } from '../../lib/utils/querystring';

const defaultState = {
  isFetching: false,
  isFetchingStation: {},
  isFetchingSettings: {},
  isSubmitting: false,
  byId: {},
  byStationId: {},
  pagingByStationId: {},
  ratingCategories: [],
  isDisabledMessage: undefined,
  hasDisabledReviews: false,
  cachedReviewsKeys: [],
  error: undefined,
  reviewSubmitted: false,
  isFlagging: false,
};

export function getReviewsByStationIdFromReducer(stationId, reducerState) {
  if (!reducerState) {
    return undefined;
  }

  const { byStationId, byId } = reducerState;
  const reviewIds = byStationId[stationId.toString()];
  return reviewIds?.length ? reviewIds.reduce((reviews, reviewId) => reviews.concat(byId[reviewId]), []) : undefined;
}

export function buildCachedReviewsKey(stationId, limit) {
  return toQueryString({ sid: stationId, limit });
}


export default function reviewsReducer(state = defaultState, action) {
  const { byId, byStationId } = state;
  const body = action?.payload;

  switch (action?.type) {
    case Action.Reviews.ReviewsPending:
      return {
        ...state,
        isFetching: true,
        error: undefined,
        isFetchingStation: {
          ...state.isFetchingStation,
          [action.meta.stationId]: true,
        },
        pagingByStationId: {
          ...state.pagingByStationId,
          [action.meta.stationId]: undefined,
        },
        cachedReviewsKeys:
          state.cachedReviewsKeys.includes(buildCachedReviewsKey(action.meta.stationId, action.meta.limit))
            ? state.cachedReviewsKeys
            : state.cachedReviewsKeys.concat([buildCachedReviewsKey(action.meta.stationId, action.meta.limit)]),
        isSubmitting: false,
        reviewSubmitted: undefined,
      };

    case Action.Reviews.ReviewsCompleted:
      if (body.reviews) {
        body.reviews.forEach((review) => {
          const stationId = review.station.id;

          byId[review.id] = review;

          if (!byStationId[stationId]) {
            byStationId[stationId] = [];
          }

          if (!byStationId[stationId].includes(review.id)) {
            byStationId[stationId].push(review.id);
          }
        });
      }

      return {
        ...state,
        isFetching: false,
        byStationId: { ...byStationId },
        isFetchingStation: {
          ...state.isFetchingStation,
          [action.meta.stationId]: false,
        },
        pagingByStationId: {
          ...state.pagingByStationId,
          [action.meta.stationId]: body.paging,
        },
      };

    case Action.Reviews.ReviewsFailed:
      return {
        ...state,
        isFetching: false,
        isFetchingStation: {
          ...state.isFetchingStation,
          [action.meta.stationId]: false,
        },
        error: body,
      };

    case Action.Reviews.ReviewSettingsPending:
      return {
        ...state,
        isFetchingSettings: {
          ...state.isFetchingSettings,
          [action.meta.stationId]: true,
        },
        error: undefined,
      };

    case Action.Reviews.ReviewSettingsCompleted:
      return {
        ...state,
        isFetchingSettings: {
          ...state.isFetchingSettings,
          [action.meta.stationId]: false,
        },
        hasDisabledReviews: body ? body.disabled : false,
        isDisabledMessage: body ? body.disabledMessage : '',
        ratingCategories: (body && body.ratingCategories) || [],
        error: (!body || body.error),
      };

    case Action.Reviews.ReviewSettingsFailed:
      return {
        ...state,
        isFetchingSettings: {
          ...state.isFetchingSettings,
          [action.meta.stationId]: false,
        },
        error: body,
      };

    case Action.Reviews.SubmitReviewPending:
      return {
        ...state,
        isFetching: false,
        isSubmitting: true,
        reviewSubmitted: undefined,
        error: undefined,
      };

    case Action.Reviews.SubmitReviewCompleted:
      return {
        ...state,
        isSubmitting: false,
        hasDisabledReviews: false,
        isDisabledMessage: '',
        reviewSubmitted: true,
        error: body?.error?.message,
      };

    case Action.Reviews.SubmitReviewFailed:
      return {
        ...state,
        isSubmitting: false,
        error: body,
      };

    default:
      return state;
  }
}
